import { render, staticRenderFns } from "./DisplayModeSilhouette.vue?vue&type=template&id=2783b310&"
import script from "./DisplayModeSilhouette.vue?vue&type=script&lang=js&"
export * from "./DisplayModeSilhouette.vue?vue&type=script&lang=js&"
import style0 from "./DisplayModeSilhouette.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports